<template>
    <vs-popup class="add-new-incoterms" id="popup" :title="`MQL to SQL assessment`" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" autocomplete="off">

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="budget" name="budget" rules="" v-slot="{ errors }">
                                <small class="label">Budget</small>
                                <vs-input v-model="form.budget" name="budget" class="w-full" label="" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="authority" name="authority" rules="" v-slot="{ errors }">
                                <small class="label">Authority</small>
                                <vs-input v-model="form.authority" name="authority" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="need" name="need" rules="" v-slot="{ errors }">
                                <small class="label">Need</small>
                                <vs-input v-model="form.need" name="need" class="w-full" label="" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="timescale" name="timescale" rules="" v-slot="{ errors }">
                                <small class="label">Timescale type</small>
                                <v-select name="timescale_type" :closeOnSelect="true" :clearable="false"
                                    v-model="form.timescale_type" :options="['weeks', 'months']"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="timescale" name="timescale" rules="max_number:999" v-slot="{ errors }">
                                <small class="label">Timescale</small>
                                <vs-input v-model="form.timescale" name="timescale" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="reason" name="reason" rules="required" v-slot="{ errors }">
                                <small class="label">Reason for advancing</small>
                                <vs-input v-model="form.reason" name="reason" class="w-full" label="" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="system_comment" name="system_comment" rules="" v-slot="{ errors }">
                                <small class="label">Comments</small>
                                <vs-textarea class="mb-0" v-model="form.comment" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-1/3">
                            <vs-button @click.stop="onClickSave('Closed NIO')" class="mt-2 ml-auto w-full" color="danger">
                                Closed - NIO
                            </vs-button>
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-button @click.stop="onClickSave('Accepted')" class="mt-2 ml-auto w-full">
                                SQL - Order Pending
                            </vs-button>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        form: {
            status: '',
            timescale_type: 'weeks'
        },
    }
}

export default {
    name: 'CreateOpportunityBantPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                await this.$refs.form.reset();
                this.open = true;
                this.id = id
            } catch (error) {

            }
        },
        async onClickCreateSite() {
            const vue = this;
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                let payload = {}
                Object.assign(payload, this.form)
                await CrmRepository.createOpprtunityBantProcess(this.id, payload);
                this.showSuccessMessage('BANT created successfully');
                await vue.$parent.refreshData();
                this.open = false;
            } catch (e) {
                this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickSave(status) {
            this.form.status = status
            const validated = await this.$refs.form.validate().then((x) => {
                return x
            })
            if (validated) {
                this.onClickCreateSite()
            }
        },
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
}
</style>
  